import { formDataToObject } from "./Forms";

const NeedToPay = (hsProfile) => {
    //returns wether the user needs to pay or not, depending on values found in the hsprofile
    if(!hsProfile) return false;

    //either adhérent codifab or ameublement français
    if (hsProfile.adherent && (hsProfile.adherent.includes("CODIFAB") || hsProfile.adherent.includes("Ameublement Français"))) {
        return false;
    }
    
    //membre communauté and date_adhesion_club_le_french_design < 12 months
    if (hsProfile.acheteur && hsProfile.acheteur.includes("Oui") && hsProfile.date_adhesion_club_le_french_design) {
        const date = new Date(hsProfile.date_adhesion_club_le_french_design); // check date format in hubspot
        const today = new Date();
        const diffTime = Math.abs(today - date);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays < 365) {
            return false;
        }
    }

    return true;
}

const IsExpiringSoon = (hsProfile) => {
    if(!hsProfile) return false;
    if (hsProfile.adherent && (hsProfile.adherent.includes("CODIFAB") || hsProfile.adherent.includes("Ameublement Français"))) {
        return false;
    }
    if (hsProfile.acheteur && hsProfile.acheteur.includes("Oui") && hsProfile.date_adhesion_club_le_french_design) {
        const date = new Date(hsProfile.date_adhesion_club_le_french_design);
        const today = new Date();
        const diffTime = Math.abs(today - date);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays >= 350 && diffDays < 365) {
            return true;
        }
    }
    return false;
}

const cat_gories_viaContainsVIACategory = (cat_gories_via) => {
    if(!cat_gories_via) return false;
    const catégoriesVIA = [
        "Donneur d'ordre",
        "Créateur - Architecte",
        "Créateur - Designer objet",
        "Créateur - Designer espace",
        "Créateur - Graphiste",
        "Créateur - Scénographe",
        "Créateur - Stratégie de marque",
        "Créateur - Stratégie digitale",
        "Producteur -  Galerie",
        "Producteur - Equipementier / Matériaux",
        "Producteur - Agenceur",
        "Producteur - Artisan d'art",
        "Producteur - Editeur",
        "Producteur - Fabricant",
        "Producteur - Distributeur",
        "Producteur - Autres"
    ]
    // should be sync across the codebase
    return cat_gories_via.split(";").some(cat => catégoriesVIA.includes(cat));
}

const userHasFullAccess = (fullUser, fullUserLoading) => {
    if(fullUserLoading) return true;
    if(!fullUser) return false;
    if(fullUser.user?.role === "admin") return true;
    if(fullUser.user?.role === "jury") return true;
    if(fullUser.user?.role === "guest") return true;
    if(NeedToPay(fullUser.hsProfile)) return false;
    // if(!cat_gories_viaContainsVIACategory(fullUser.hsProfile?.cat_gories_via)) return false;
    return true;   
}

const validateFrom = (form) => {

    // console.log(form);

    const inputNames = Array.from(form.keys());
    for(let i = 0; i < inputNames.length; i++) {
        if(form.get(inputNames[i]).required && !form.get(inputNames[i]).value) {
            window.scrollTo(0, form.get(inputNames[i]).offsetTop);
            form.get(inputNames[i]).focus();
            setTimeout(() => {
                alert("Veuillez remplir tous les champs obligatoires");
            }, 100);
            return false;
        }
    }

    return true;
}

const validateStep1ASDE2024 = (form, projets) => {

    const formObject = formDataToObject(form);
    let hasMissingField = false;
    let missingFieldNames = [];

    if (!formObject.type_projets) missingFieldNames.push("Quelle est votre spécialité?");
    if (!formObject.rechercheModel) missingFieldNames.push("Modèles économiques");
    if (!formObject.rechercheProcess) missingFieldNames.push("Process innovants");
    if (!formObject.rechercheProduction) missingFieldNames.push("Production locale");
    if (!formObject.rechercheFlex) missingFieldNames.push("Flexibilité");
    if (!formObject.criteres) missingFieldNames.push("Profil des sociétés recherchées ?");

    if (missingFieldNames.length > 0) {
        alert(`Veuillez remplir tous les champs obligatoires: ${missingFieldNames.join(", ")}`);
        return false;
    }

    if (formObject.mobilier === "oui") {
        if (!formObject.mobilierType) missingFieldNames.push("Type Mobilier");
        if (!formObject.mobilierMaterial) missingFieldNames.push("Materiau Mobilier");
        if (!formObject.mobilierScale) missingFieldNames.push("Echelle Mobilier");
        if (!formObject.mobilierExport) missingFieldNames.push("Export Mobilier");
    }

    if (formObject.artisanat === "oui") {
        if (!formObject.artisanatType) missingFieldNames.push("Type Artisanat");
        if (!formObject.artisanatScale) missingFieldNames.push("Echelle Artisanat");
        if (!formObject.artisanatExport) missingFieldNames.push("Export Artisanat");
    }

    // if (formObject.artisanat === "non" && formObject.mobilier === "non") {
    //     missingFieldNames.push("Artisanat d'art ou mobilier");
    // }

    if (projets.find(proj => !proj.validated)) {
        alert("Veuillez confirmer tous les projets");
        return false;
    }

    if (projets.filter(proj => proj.validated === true).length === 0) {
        alert("Veuillez confirmer au moins un projet");
        return false;
    }

    if (missingFieldNames.length > 0) {
        alert(`Veuillez remplir tous les champs obligatoires: ${missingFieldNames.join(", ")}`);
        return false;
    }

    return true;
}

const validateStep1BSDE2024 = (form, projets) => {
    const formObject = formDataToObject(form)

    // console.log(formObject)
    let missingFieldNames = [];

    if (!formObject.type_projets) missingFieldNames.push("Type de projets");
    if (!formObject.rechercheModel) missingFieldNames.push("Modèles économiques");
    if (!formObject.rechercheProcess) missingFieldNames.push("Process innovants");
    if (!formObject.rechercheProduction) missingFieldNames.push("Production locale");
    if (!formObject.rechercheFlex) missingFieldNames.push("Flexibilité");
    // if (!formObject.criteres) missingFieldNames.push("Criteres");

    if (missingFieldNames.length > 0) {
        alert(`Veuillez remplir tous les champs obligatoires: ${missingFieldNames.join(", ")}`);
        return false;
    }

    if (formObject.mobilier === "oui") {
        if (!formObject.mobilierType) missingFieldNames.push("Type Mobilier");
        if (!formObject.mobilierMaterial) missingFieldNames.push("Materiau Mobilier");
        if (!formObject.mobilierScale) missingFieldNames.push("Echelle Mobilier");
        if (!formObject.mobilierExport) missingFieldNames.push("Export Mobilier");
    }

    if (formObject.artisanat === "oui") {
        if (!formObject.artisanatType) missingFieldNames.push("Type Artisanat");
        if (!formObject.artisanatScale) missingFieldNames.push("Echelle Artisanat");
        if (!formObject.artisanatExport) missingFieldNames.push("Export Artisanat");
    }

    // if (formObject.artisanat === "non" && formObject.mobilier === "non") {
    //     missingFieldNames.push("Artisanat d'art ou mobilier");
    // }

    if (projets.find(proj => !proj.validated)) {
        alert("Veuillez confirmer tous les projets");
        return false;
    }

    if (projets.filter(proj => proj.validated === true).length === 0) {
        alert("Veuillez confirmer au moins un projet");
        return false;
    }

    if (missingFieldNames.length > 0) {
        alert(`Veuillez remplir tous les champs obligatoires: ${missingFieldNames.join(", ")}`);
        return false;
    }
    return true;
}

const validateStep2SDE2024 = (form) => {

    if(!form.has("consent")){
        alert("Veuillez remplir tous les champs");
        return false;
    }

    for (const field of form.entries()) {
        if (
            (field[0] === "name1" ||
                field[0] === "firstname1" ||
                field[0] === "email1" ||
                field[0] === "mobilephone1" ||
                field[0] === "landline1" ||
                field[0] === "jobtitle1" ||
                field[0] === "name2" ||
                field[0] === "firstname2" ||
                field[0] === "email2" ||
                field[0] === "mobilephone2" ||
                field[0] === "landline2" ||
                field[0] === "jobtitle2" ||
                field[0] === "presentiel") && field[1] === ""
        ) {
            alert("Veuillez remplir tous les champs");
            return false;
        }
    }
    return true;
}

const validateStep1ASDO2024 = (form, projets) => {

    const formObject = formDataToObject(form);
    let missingFieldNames = [];

    if (!formObject.interne &&
        !formObject.etude &&
        !formObject.collab &&
        !formObject.da &&
        !formObject.premiere) missingFieldNames.push("Vos savoir-faire, matériaux et techniques");

    if (missingFieldNames.length > 0) {
        alert(`Veuillez remplir tous les champs obligatoires: ${missingFieldNames.join(", ")}`);
        return false;
    }

    if (projets.find(proj => !proj.validated)) {
        alert("Veuillez confirmer tous les projets");
        return false;
    }

    if (projets.filter(proj => proj.validated === true).length === 0) {
        alert("Veuillez confirmer au moins un projet");
        return false;
    }

    return true;
}

const validateStep1BSDO2024 = (form, projets) => {

    if (projets.find(proj => !proj.validated)) {
        alert("Veuillez confirmer tous les projets");
        return false;
    }

    if (projets.filter(proj => proj.validated === true).length < 3) {
        alert("Veuillez confirmer au moins trois projets");
        return false;
    }
    
    return true;
}

const validateStep2SDO2024 = (form) => {
    return true;
}

const validateStep1FD1002025 = (form) => {
    const formObject = formDataToObject(form);
    let missingFieldNames = [];

    if (!formObject.culture_francaise) missingFieldNames.push("Culture française");
    if (!formObject.contact_nom) missingFieldNames.push("Nom du contact");
    if (!formObject.contact_prenom) missingFieldNames.push("Prénom du contact");
    if (!formObject.contact_mail) missingFieldNames.push("Email du contact");
    if (!formObject.contact_telephone) missingFieldNames.push("Téléphone du contact");

    if (missingFieldNames.length > 0) {
        alert(`Veuillez remplir tous les champs obligatoires.`);
        return false;
    }

    return true;
}

export {
    NeedToPay,
    IsExpiringSoon,
    cat_gories_viaContainsVIACategory,
    userHasFullAccess,
    validateFrom,
    validateStep1ASDE2024,
    validateStep1BSDE2024,
    validateStep2SDE2024,

    validateStep1ASDO2024,
    validateStep1BSDO2024,
    validateStep2SDO2024,

    validateStep1FD1002025
}